import { Header, Icon } from '@iqueue/ui-kit'
import cn from 'classnames'
import ProductionDiffLine from '../ProductionDiffLine'
import { t } from '../../../hooks/useTranslate'
import HourlyProductionChart from './HourlyProductionChart'
import NodesTrafficLight from '../NodesTrafficLight'
import { UNIT_PRESSURE, UNIT_TEMPERATURE, UNIT_VOLUME } from '../Measurement'

export default function AssemblyPointCard(props) {
  const {
    /*
     pressureInputHourlyChart={ Object.values(pathOr({}, ['PRESSURE_INPUT', 'hourlyChart'], data)) }
     summaryPressureInput={ Object.values(pathOr({}, ['PRESSURE_INPUT', 'summary'], data)) }
     pressureOutputHourlyChart={ Object.values(pathOr({}, ['PRESSURE_OUTPUT', 'hourlyChart'], data)) }
     summaryPressureOutput={ Object.values(pathOr({}, ['PRESSURE_INPUT', 'summary'], data)) }
     temperatureHourlyChart={ Object.values(pathOr({}, ['TEMPERATURE', 'hourlyChart'], data)) }
     summaryTemperature={ Object.values(pathOr({}, ['PRESSURE_INPUT', 'summary'], data)) }
     */

    pressureInputHourlyChart = [],
    pressureInputSummary: {
      hourlyValue: hourlyValuePI = 0,
      pastHourValue: pastHourValuePI = 0,
    } = {},

    pressureOutputHourlyChart = [],
    // pressureOutputSummary: {
    //   hourlyValue: hourlyValuePO = 0,
    //   pastHourValue: pastHourValuePO = 0,
    // } = {},

    temperatureHourlyChart = [],
    temperatureSummary: {
      hourlyValue: hourlyValueT = 0,
      pastHourValue: pastHourValueT = 0,
    } = {},

    summary: {
      hourlyValue = 0,
      pastHourValue = 0,
      dailyValue = 0,
      pastDayValue = 0,
      monthlyValue = 0,
      pastMonthValue = 0,
    } = {},

    nodes,
    className,
    type,
    name = 'Assembly point',
    onClick,
  } = props

  return <div
    className={ cn('gas-and-oil-card interactive', className) }
    onClick={ onClick }
  >
    <Header
      title={ <>
        <b><Icon filled style={ { marginRight: '0.8rem' } }>oil_barrel</Icon></b>
        <span>{ name }</span>
      </> }
      subtitle={ t(`type.node.${ type }`) }
      extra={ <NodesTrafficLight nodes={ nodes }/> }
    />

    <div className={ 'content' }>
      <HourlyProductionChart
        subtitle={ <span>
  { t('type.sensor.PRESSURE') } { t('type.pressure.at') }{ ' ' }
          <span
            style={ { color: 'var(--iq-accent)' } }>{ t('type.pressure.input') }</span> { t('type.pressure.and') }{ ' ' }
          <span style={ { color: 'var(--iq-accent-secondary)' } }>{ t('type.pressure.output') }</span>
</span> }
        unit={ UNIT_PRESSURE }
        hourlyData={ pressureInputHourlyChart }
        extraData={ pressureOutputHourlyChart }
        currentHourValue={ hourlyValuePI }
        pastHourValue={ pastHourValuePI }
      />

      <HourlyProductionChart
        subtitle={ 'Температура' }
        unit={ UNIT_TEMPERATURE }
        hourlyData={ temperatureHourlyChart }
        currentHourValue={ hourlyValueT }
        pastHourValue={ pastHourValueT }
      />

      <ProductionDiffLine
        title={ t('productionLabels.hourlyProduction') }
        current={ hourlyValue }
        past={ pastHourValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.dailyProduction') }
        current={ dailyValue }
        past={ pastDayValue }
        unit={ UNIT_VOLUME }
      />

      <ProductionDiffLine
        title={ t('productionLabels.monthlyProduction') }
        current={ monthlyValue }
        past={ pastMonthValue }
        unit={ UNIT_VOLUME }
      />

      {/*<div>*/ }
      {/*  <p/>*/ }
      {/*  <div>Текущее давление на входе</div>*/ }
      {/*  <div>Текущее давление на выходе</div>*/ }
      {/*</div>*/ }
    </div>
  </div>
}
